import React, { useEffect, useState } from 'react'
import ButtonWithLoader from './ButtonWithLoader'
import Select from './Select'
import { useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import { FETCH_UNITS, SELECT_UNIT } from '../redux/unitsReducer'
import { useDispatch } from 'react-redux'
import { CHANGE_LESSON_PLAN, FETCH_LESSON_PLANS } from '../redux/lessonPlansReducer'
import { useParams } from 'react-router-dom'
import OutlinedButtonWithLoader from './OutlinedButtonWithLoader'
import { EXTEND_LESSON } from '../redux/lessonReducer'
interface Props {
  onClose: () => void
}

const LessonSettingsModal = ({ onClose }: Props) => {
  const { lessonId } = useParams()
  const [selectedLessonPlanId, setSelectedLessonPlanId] = useState<string | null>(null)
  const units = useSelector((state: RootReducer) => state.unitsReducer.units)
  const selectedUnitId = useSelector((state: RootReducer) => state.unitsReducer.selectedUnitId)
  const lessonUnitId = useSelector((state: RootReducer) => state.lessonReducer.lesson?.unit_id)
  const dispatch = useDispatch()

  const lessonPlans = useSelector((state: RootReducer) => {
    if (!selectedUnitId) return []
    return state.lessonPlansReducer.lessonPlans[parseInt(selectedUnitId)] ?? []
  })

  useEffect(() => {
    setSelectedLessonPlanId(null)
  }, [selectedUnitId])

  useEffect(() => {
    if (lessonUnitId) {
      dispatch(SELECT_UNIT({ unitId: lessonUnitId.toString() }))
    }
  }, [lessonUnitId, dispatch])

  useEffect(() => {
    dispatch(FETCH_UNITS())
  }, [dispatch])

  useEffect(() => {
    if (selectedUnitId) {
      dispatch(FETCH_LESSON_PLANS({ unitId: parseInt(selectedUnitId) }))
    }
  }, [selectedUnitId, dispatch])

  const handleChangeLessonPlan = () => {
    if (!selectedLessonPlanId || !lessonId) return
    dispatch(CHANGE_LESSON_PLAN({ lessonId: lessonId, lessonPlanId: selectedLessonPlanId }))
    onClose()
  }

  const handleExtendLesson = () => {
    if (!lessonId) return
    dispatch(EXTEND_LESSON({ id: lessonId }))
    onClose()
  }

  return (
    <div className="max-w-[26rem] bg-slateGray flex-1 mt-20 rounded-lg h-fit p-10">
      <p className="text-white text-22 text-center">Change lesson Unit/Lesson plan</p>
      <div className="h-5" />
      <Select
        options={units.map((unit) => ({ value: unit.id.toString(), label: unit.name }))}
        placeholder="Select Unit"
        onChange={(value) => {
          dispatch(SELECT_UNIT({ unitId: value }))
        }}
        value={selectedUnitId ?? ''}
      />
      <div className="h-5" />
      <Select
        options={lessonPlans.map((lessonPlan) => ({ value: lessonPlan.id.toString(), label: lessonPlan.name }))}
        placeholder="Select Lesson Plan"
        onChange={(value) => {
          setSelectedLessonPlanId(value)
        }}
        value={selectedLessonPlanId ?? ''}
      />
      <div className="h-5" />
      <ButtonWithLoader onClick={handleChangeLessonPlan} label="Chose" />
      <div className="h-3" />
      <OutlinedButtonWithLoader onClick={handleExtendLesson} label="Extend Lesson" />
    </div>
  )
}

export default LessonSettingsModal
